<template>
    <div class="demandSignForReceiptForm commonFormStyles">
        <HeaderNav
            header-title="需求签收单"
            left-icon-name="2"
            right-icon-name="3"
            :extr="{ leftCallBack }"
        ></HeaderNav>
        <section class="formList">
            <van-form validate-first>
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <div slot="title" class="title">
                            <i class="iconfont icondingdan"></i>需求签收单
                        </div>
                        <van-field
                            label="需求签收单编号"
                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                            input-align="right"
                            placeholder="自动"
                            v-model="formData.AllocationNumber"
                            disabled
                        ></van-field>
                        <van-field
                            label="需求部门"
                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                            input-align="right"
                            placeholder="自动"
                            v-model="formData.ApplyDeptName"
                            disabled
                        ></van-field>
                        <van-field
                            label="汽运单编号"
                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                            input-align="right"
                            placeholder="自动"
                            v-model="formData.YsdNumber"
                            disabled
                        ></van-field>
                        <van-field
                            label="供货单编号"
                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                            input-align="right"
                            placeholder="自动"
                            v-model="formData.SupplyNumber"
                            disabled
                        ></van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_18@2x.png')"
                            label="采购计划编号"
                            placeholder="自动"
                            input-align="right"
                            disabled
                            v-model="formData.CollectNumber"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_4@2x.png')"
                            label="供应商"
                            placeholder="自动"
                            input-align="right"
                            v-model="formData.SupplierName"
                            disabled
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            label="车牌号"
                            placeholder="自动"
                            input-align="right"
                            v-model="formData.PlateNumber"
                            disabled
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_9@2x.png')"
                            label="司机电话"
                            placeholder="自动"
                            input-align="right"
                            v-model="formData.DriverPhone"
                            disabled
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_4@2x.png')"
                            label="物流单位"
                            placeholder="自动"
                            input-align="right"
                            v-model="formData.TransportName"
                            disabled
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_2@2x.png')"
                            label="计量类别"
                            input-align="right"
                            disabled
                        >
                            <template #input>
                                <van-radio-group disabled v-model="formData.MeasureType" direction="horizontal">
                                    <van-radio :name="0">
                                        计件
                                    </van-radio>
                                    <van-radio :name="1">
                                        计量
                                    </van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                            label="核对人"
                            placeholder="自动"
                            input-align="right"
                            v-model="formData.CheckUserName1"
                            disabled
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            label="到场时间"
                            placeholder="自动"
                            input-align="right"
                            v-model="formData.IntoTime"
                            disabled
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                            label="核对时间"
                            placeholder="自动"
                            input-align="right"
                            v-model="formData.CheckTime1"
                            disabled
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            label="签收人"
                            placeholder="自动"
                            input-align="right"
                            v-model="formData.SignUserName1"
                            disabled
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                            label="签收时间"
                            placeholder="自动"
                            input-align="right"
                            v-model="formData.SignTime1"
                            disabled
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                            label="备注"
                            placeholder="自动"
                            input-align="right"
                            v-model="formData.Remarks"
                            disabled
                        >
                        </van-field>
                    </van-collapse-item>
                    <van-collapse-item name="2">
                        <div slot="title" class="title">
                            供应清单
                        </div>
                        <div class="commonFormStyles">
                            <div
                                class=""
                            >
                                <!-- <p class="title">
                                    <span>{{ formData.MaterialName }}</span>
                                    <span>{{ formData.MaterialCode }}</span>
                                </p> -->
                                <template v-for="item in MaterialAllocationList">
                                    <div class="item_card_" :key="item.Id">
                                        <div class="list_item_card list_item_card3">
                                            <van-field
                                                label="物料代码"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                placeholder="自动"
                                                v-model="item.MaterialCode"
                                                disabled
                                            ></van-field>
                                            <van-field
                                                label="物料短描述"
                                                :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                                input-align="right"
                                                placeholder="自动"
                                                v-model="item.MaterialShortName"
                                                disabled
                                            ></van-field>
                                            <van-field
                                                label="物料长描述"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                placeholder="自动"
                                                v-model="item.MaterialName"
                                                disabled
                                            ></van-field>
                                            <van-field
                                                label="单位"
                                                :left-icon="require('@/assets/images/icons/icon_2@2x.png')"
                                                input-align="right"
                                                placeholder="自动"
                                                v-model="item.Unit"
                                                disabled
                                            ></van-field>
                                            <van-field
                                                label="申请数量"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                placeholder="自动"
                                                v-model="item.ApplyCount"
                                                disabled
                                            ></van-field>
                                            <!-- <van-field
                                                label="供应数量"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                placeholder="自动"
                                                v-model="item.SupplyCount"
                                                readonly
                                            ></van-field> -->
                                            <!-- <van-field
                                                label="到场数量"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                placeholder="自动"
                                                v-model="item.AppearanceDetection"
                                                readonly
                                            ></van-field> -->
                                            <van-field
                                                label="分配数量"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                placeholder="自动"
                                                v-model="item.SupplyCount"
                                                disabled
                                            ></van-field>
                                        </div>
                                        <div class="list_item_card list_item_card3">
                                            <van-field
                                                label="签收数量"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                placeholder="请输入"
                                                v-model="item.SignCount"
                                                :disabled="formData.Status !== 1"
                                            ></van-field>
                                            <van-field
                                                label="外观检测"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                placeholder="请输入"
                                                v-model="item.AppearanceDetection"
                                                :disabled="formData.Status !== 1"
                                            ></van-field>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </van-collapse-item>
                </van-collapse>
            </van-form>
        </section>
        <div class="currencyFooterStyle">
            <van-button class="btn save-btn" :disabled="formData.Status !== 1" @click="handleDetection">
                二次检测
            </van-button>
            <van-button class="btn save-btn" :disabled="formData.Status !== 1" @click="handleSign">
                签收
            </van-button>
            <van-button class="btn save-btn" :disabled="formData.Status !== 1" @click="handleSave">
                保存
            </van-button>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    name: 'demand-sign-for-receipt-form',
    beforeRouteLeave(to, from, next) {
        if (to.name === 'demandSignForReceipt') {
            this.$store.commit('noKeepAlive', 'demand-sign-for-receipt-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            titleName: '新建',
            // 折叠面板-选中
            activeNames: ['1', '2', '3'],
            // 表单数据
            formData: {
                CheckTime1: '',
                CheckUserId1: '',
                CheckUserName1: '',
                CollectNumber: '',
                ContractNo: '',
                ContractNumber: '',
                DeliverLocationId: '',
                DeliverLocationName: '',
                DriverName: '',
                DriverPhone: '',
                Id: '',
                InstockState: 0,
                IntoTime: '',
                MaterialList: null,
                MeasureType: 1,
                PlateNumber: '',
                Remarks: '',
                SignTime1: null,
                SignUserId1: '',
                SignUserName1: '',
                SortNum: null,
                SupplierId: '',
                SupplierName: '',
                SupplyNumber: '',
                TransportName: '',
                YsdNumber: '',
            },
            MaterialAllocationList: [],
        };
    },
    async activated() {
    },
    computed: {},
    async created() {
        const res = await this.getDetailFun();
        this.formData = { ...res.Ysd, ...res.YsdAllocation };
        this.MaterialAllocationList = res.MaterialAllocationList || [];
    },
    mounted() {},
    methods: {
        leftCallBack() {
            this.$router.isBack = 1;
            this.$router.push({
                name: 'demandSignForReceipt',
            });
        },
        handleDetection() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'secondaryTestingForm',
                params: {
                    data: this.formData,
                    type: 'demandSignForReceiptForm',
                },
            });
        },
        handleSave() {
            this.$toast.loading({ overlay: true, duration: 0 });
            this.$axios
                .post('/interfaceApi/procurement/ysd/update_dept_allaction_info', this.MaterialAllocationList)
                .then(res => {
                    if (res) {
                        this.$toast('保存成功！');
                    }
                }).catch(error => {
                    this.$toast({
                        type: 'html',
                        message: error.ErrorCode.Message,
                    });
                }).finally(() => {
                    this.$toast.clear();
                });
        },
        async handleSign() {
            const res = await this.signForReceiptRequest(this.$route.params.data.id);
            if (res) {
                this.$toast('签收成功');
                this.leftCallBack();
            }
        },
        // 获取详情
        getDetailFun() {
            return this.$axios.$get('/interfaceApi/procurement/ysd/get_dept_allaction_info/' + this.$route.params.data.id, { defEx: true });
        },
        // 签收单签收
        signForReceiptRequest(id) {
            return this.$axios.$get(`/interfaceApi/procurement/ysd/allaction_sign/${id}`, { defEx: true });
        },
    },

};
</script>
<style lang="stylus"></style>
